import md5 from 'md5';
import { strogging } from '@shd/jslib/infra';
import * as Sentry from '@sentry/browser';
import { isMobile } from '../browserDetect';

export const getReferralCode = (userId: string) => {
  const encodedId = Buffer.from(userId, 'utf8');
  const hashed = Uint8Array.from(Buffer.from(md5(encodedId), 'hex'));

  const alphabet =
    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVXYZ';
  const hashOut = Array(hashed.length)
    .fill(0)
    .map((_, i) => alphabet[hashed[i] % alphabet.length])
    .join('');
  return hashOut.slice(6);
};

export const hashClipFilenameToKey = (fileName: string) => {
  const encodedId = Buffer.from(fileName, 'utf8');
  const hashed = Uint8Array.from(Buffer.from(md5(encodedId), 'hex'));

  const alphabet =
    '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVXYZ';
  const hashOut = Array(hashed.length)
    .fill(0)
    .map((_, i) => alphabet[hashed[i] % alphabet.length])
    .join('');
  return hashOut;
};

export interface ShareData {
  title?: string;
  text?: string;
  url?: string;
}

export const sharePage = (shareData: ShareData) => {
  const { title, text, url } = shareData;
  if (navigator.canShare({ title, text, url })) {
    navigator.share({ title, text, url }).catch((error) => {
      strogging.log('sharePage utils - navigator.share error', error);
      Sentry.captureException(error);
    });
  }
};

export const isFirefox = () => navigator.userAgent.includes('Firefox');

export const getVeWorkerOverlayUrl = (
  assignedUrlOvl = '',
  nginxAddrLocal = '',
  nginxAddrExternal = ''
) => {
  const overlayUrl = assignedUrlOvl.replace(nginxAddrLocal, nginxAddrExternal);
  // if we are on mobile, we create a vlc url, else on desktop the
  // rtmp url works ok
  if (isMobile.any()) {
    return `vlc-x-callback://x-callback-url/stream?url=${overlayUrl}`;
  }
  return overlayUrl;
};

export function deepClone<T>(obj: T): T {
  try {
    return typeof structuredClone === 'function'
      ? structuredClone(obj)
      : JSON.parse(JSON.stringify(obj));
  } catch (err) {
    return JSON.parse(JSON.stringify(obj));
  }
}

export function escapeRegExp(string: string): string {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
